export default __webpack_public_path__ + "static/media/ai_trading_3.05b9dc7c.png";